import { c as _c } from "react/compiler-runtime";
import NextImage from "next/image";
import { useTranslation } from "react-i18next";
import ErrorBannerMobile from "@/assets/images/common/error-banner-mobile.webp";
import ErrorBannerPC from "@/assets/images/common/error-banner-pc.webp";
import LocaleLink from "@/lib/i18n/locale-link";
import { Button } from "../ui/button";
interface ErrorFallbackProps {
  errorType?: string;
}
export default function ErrorFallback(t0) {
  const $ = _c(62);
  const {
    errorType
  } = t0;
  const {
    t
  } = useTranslation();
  let title;
  let description;
  let isKnownError;
  if (errorType === "banned") {
    let t1;
    if ($[0] !== t) {
      t1 = t("error.banned.title");
      $[0] = t;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    title = t1;
    let t2;
    if ($[2] !== t) {
      t2 = t("error.banned.description");
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    description = t2;
    isKnownError = true;
  } else {
    if (errorType === "user_blacklisted_login") {
      let t1;
      if ($[4] !== t) {
        t1 = t("error.userBlacklisted.title");
        $[4] = t;
        $[5] = t1;
      } else {
        t1 = $[5];
      }
      title = t1;
      let t2;
      if ($[6] !== t) {
        t2 = t("error.userBlacklisted.description");
        $[6] = t;
        $[7] = t2;
      } else {
        t2 = $[7];
      }
      description = t2;
      isKnownError = true;
    } else {
      if (errorType === "account_already_linked_to_different_user") {
        let t1;
        if ($[8] !== t) {
          t1 = t("error.accountAlreadyLinked.title");
          $[8] = t;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        title = t1;
        let t2;
        if ($[10] !== t) {
          t2 = t("error.accountAlreadyLinked.description");
          $[10] = t;
          $[11] = t2;
        } else {
          t2 = $[11];
        }
        description = t2;
        isKnownError = true;
      } else {
        if (errorType === "account_provider_already_linked") {
          let t1;
          if ($[12] !== t) {
            t1 = t("error.accountAlreadyLinked.title");
            $[12] = t;
            $[13] = t1;
          } else {
            t1 = $[13];
          }
          title = t1;
          let t2;
          if ($[14] !== t) {
            t2 = t("error.accountAlreadyLinked.description");
            $[14] = t;
            $[15] = t2;
          } else {
            t2 = $[15];
          }
          description = t2;
          isKnownError = true;
        } else {
          if (errorType === "account_not_linked") {
            let t1;
            if ($[16] !== t) {
              t1 = t("error.emailAlreadyRegistered.title");
              $[16] = t;
              $[17] = t1;
            } else {
              t1 = $[17];
            }
            title = t1;
            let t2;
            if ($[18] !== t) {
              t2 = t("error.emailAlreadyRegistered.description");
              $[18] = t;
              $[19] = t2;
            } else {
              t2 = $[19];
            }
            description = t2;
            isKnownError = true;
          } else {
            if (errorType === "user_cancelled_authorize") {
              let t1;
              if ($[20] !== t) {
                t1 = t("error.authorizationCancelled.title");
                $[20] = t;
                $[21] = t1;
              } else {
                t1 = $[21];
              }
              title = t1;
              let t2;
              if ($[22] !== t) {
                t2 = t("error.authorizationCancelled.description");
                $[22] = t;
                $[23] = t2;
              } else {
                t2 = $[23];
              }
              description = t2;
              isKnownError = true;
            } else {
              if (errorType === "tongdun_verification_failed") {
                let t1;
                if ($[24] !== t) {
                  t1 = t("error.tongdunVerificationFailed.title");
                  $[24] = t;
                  $[25] = t1;
                } else {
                  t1 = $[25];
                }
                title = t1;
                let t2;
                if ($[26] !== t) {
                  t2 = t("error.tongdunVerificationFailed.description");
                  $[26] = t;
                  $[27] = t2;
                } else {
                  t2 = $[27];
                }
                description = t2;
                isKnownError = true;
              } else {
                if (errorType === "missing_oauth_params") {
                  let t1;
                  if ($[28] !== t) {
                    t1 = t("error.missingOauthParams.title");
                    $[28] = t;
                    $[29] = t1;
                  } else {
                    t1 = $[29];
                  }
                  title = t1;
                  let t2;
                  if ($[30] !== t) {
                    t2 = t("error.missingOauthParams.description");
                    $[30] = t;
                    $[31] = t2;
                  } else {
                    t2 = $[31];
                  }
                  description = t2;
                  isKnownError = true;
                } else {
                  let t1;
                  if ($[32] !== t) {
                    t1 = t("error.generic.title");
                    $[32] = t;
                    $[33] = t1;
                  } else {
                    t1 = $[33];
                  }
                  title = t1;
                  let t2;
                  if ($[34] !== t) {
                    t2 = t("error.generic.description");
                    $[34] = t;
                    $[35] = t2;
                  } else {
                    t2 = $[35];
                  }
                  description = t2;
                  isKnownError = false;
                }
              }
            }
          }
        }
      }
    }
  }
  let t1;
  if ($[36] !== isKnownError || $[37] !== t) {
    t1 = isKnownError ? <LocaleLink href="/"><Button variant="outline" className="min-w-[6.75rem] mx-auto border-black">{t("error.button.backToHome")}</Button></LocaleLink> : <Button variant="outline" onClick={_temp} className="min-w-[6.75rem] mx-auto border-black">{t("error.button.reloadPage")}</Button>;
    $[36] = isKnownError;
    $[37] = t;
    $[38] = t1;
  } else {
    t1 = $[38];
  }
  const buttonDom = t1;
  let t2;
  if ($[39] !== title) {
    t2 = <h1 className="text-lg md:text-3xl font-['DINPro'] font-medium text-black px-4  text-center">{title}</h1>;
    $[39] = title;
    $[40] = t2;
  } else {
    t2 = $[40];
  }
  let t3;
  if ($[41] !== description) {
    t3 = <p className="mt-2.5 md:mt-3 text-xs md:text-base text-black max-w-67.5 md:max-w-200 text-center">{description}</p>;
    $[41] = description;
    $[42] = t3;
  } else {
    t3 = $[42];
  }
  let t4;
  if ($[43] !== buttonDom) {
    t4 = <div className="hidden md:flex md:mt-8 justify-center  ">{buttonDom}</div>;
    $[43] = buttonDom;
    $[44] = t4;
  } else {
    t4 = $[44];
  }
  let t5;
  if ($[45] !== t) {
    t5 = t("error.banner.alt");
    $[45] = t;
    $[46] = t5;
  } else {
    t5 = $[46];
  }
  let t6;
  if ($[47] !== t5) {
    t6 = <NextImage src={ErrorBannerPC} alt={t5} className="w-full max-w-[1200px] aspect-1200/358 h-auto mt-25 hidden md:block" />;
    $[47] = t5;
    $[48] = t6;
  } else {
    t6 = $[48];
  }
  let t7;
  if ($[49] !== t) {
    t7 = t("error.banner.alt");
    $[49] = t;
    $[50] = t7;
  } else {
    t7 = $[50];
  }
  let t8;
  if ($[51] !== t7) {
    t8 = <NextImage src={ErrorBannerMobile} alt={t7} className="mt-7.5  h-auto w-88.75 aspect-355/106  block md:hidden" />;
    $[51] = t7;
    $[52] = t8;
  } else {
    t8 = $[52];
  }
  let t9;
  if ($[53] !== buttonDom) {
    t9 = <div className="flex justify-center mt-3 md:hidden">{buttonDom}</div>;
    $[53] = buttonDom;
    $[54] = t9;
  } else {
    t9 = $[54];
  }
  let t10;
  if ($[55] !== t2 || $[56] !== t3 || $[57] !== t4 || $[58] !== t6 || $[59] !== t8 || $[60] !== t9) {
    t10 = <div className="flex min-h-dvh w-screen flex-col  items-center pt-45 bg-white px-0">{t2}{t3}{t4}{t6}{t8}{t9}</div>;
    $[55] = t2;
    $[56] = t3;
    $[57] = t4;
    $[58] = t6;
    $[59] = t8;
    $[60] = t9;
    $[61] = t10;
  } else {
    t10 = $[61];
  }
  return t10;
}
function _temp() {
  return window.location.reload();
}